import { useCallback, useEffect, useState } from 'react';
import FullPageLoader from '../FullPageLoader/FullPageLoader';
import ModalAlert from './ModalAlert/ModalAlert';

export const InternetConnectionCheckModal = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [isChecking, setIsChecking] = useState(false);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
  }, []);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
  }, []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  const checkConnection = useCallback(async () => {
    setIsChecking(true);
    setTimeout(() => {
      if (navigator.onLine) {
        handleOnline();
      }

      setIsChecking(false);
    }, 0);
  }, [handleOnline]);

  if (isOnline) return null;

  return isChecking ? (
    <FullPageLoader />
  ) : (
    <ModalAlert
      isOpen={!isOnline}
      text="Відсутнє з'єднання з інтернетом. Перевірте підключення, і спробуйте ще раз"
      onClose={checkConnection}
    />
  );
};
